import React, { useState } from 'react';
import { NavBar } from './components/NavBar';
import { MoodBoard } from './components/MoodBoard';
import { Footer } from './components/Footer';
import { AboutPage } from './pages/AboutPage';
import { DinnersPage } from './pages/DinnersPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const handleNavigate = (page: string) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-white" data-id="element-0">
      <NavBar currentPage={currentPage} onNavigate={handleNavigate} data-id="element-1" />

      {currentPage === 'home' && <div className="relative" data-id="element-2">
          {/* Decorative clouds - positioned behind all content, hidden on mobile */}
          <img src="https://cdn.magicpatterns.com/uploads/kVDqeyYfvjxAdu8iHxzwBK/one_thing_i_wish_i_had_access_to_but_dont_is..._(16).png" alt="" className="absolute right-0 pointer-events-none select-none cloud-right" style={{
        zIndex: 0,
        width: '45%',
        height: 'auto',
        bottom: '20%',
        opacity: 1
      }} draggable={false} data-id="element-3" />
          <img src="https://cdn.magicpatterns.com/uploads/mqwcMYNHsdrKEbupj4zQow/one_thing_i_wish_i_had_access_to_but_dont_is..._(17).png" alt="" className="hidden md:block absolute pointer-events-none select-none" style={{
        zIndex: 0,
        width: '40%',
        height: 'auto',
        bottom: '20%',
        left: '-2%',
        opacity: 1
      }} draggable={false} data-id="element-4" />
          <div className="relative" style={{
        zIndex: 1
      }} data-id="element-5">
            <MoodBoard data-id="element-6" />
          </div>
        </div>}

      {currentPage === 'about' && <AboutPage data-id="element-7" />}
      {currentPage === 'dinners' && <DinnersPage data-id="element-8" />}

      <Footer currentPage={currentPage} onNavigate={handleNavigate} data-id="element-9" />
    </div>;
}